import React from 'react'
import { PageHeader } from '@reapit/elements'

const LoginFailedBlock: React.FC = () => {
  return (
    <PageHeader
      avatar={{
        src: 'error.png',
        type: 'image',
      }}
      hasMaxWidth
      pageTitle={{
        children: "Welcome! It looks like you're not a registered user...",
        hasBoldText: true,
      }}
      pageSubtitle={{
        children:
          'To use Prospector Pro you need to have an account, please contact support@prospectorpro.co.uk to discuss this.',
      }}
    />
  )
}

export default LoginFailedBlock
